import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { diffWords } from 'diff';
import styles from '../styles.scss';
import Double from './double';

const Data = props => {
  const { item } = props;
  return (
    <div className={styles.dataBlock}>
      <div className={styles.title}>{item.typeName}</div>
      {[1, 15, 16].includes(item.typeId) && (
        <div className={styles.value}>
          {diffWords(item.prevValue || '', item.newValue || '').map(val => (
            <React.Fragment>
              {!/^\n+$/.test(val.value) && (
                <React.Fragment>
                  {val.added || val.removed ? (
                    <span className={cn({ [styles.added]: val.added, [styles.deleted]: val.removed })}>
                      {val.value}
                    </span>
                  ) : (
                    val.value
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      {item.typeId === 4 && <Double item={item} />}
      {![1, 15, 16, 4].includes(item.typeId) && (
        <div className={styles.value}>
          {item.prevValue && <span className={styles.prev}>{item.prevValue}</span>}
          {item.newValue && <span className={styles.new}>{item.newValue}</span>}
        </div>
      )}
    </div>
  );
};

Data.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Data;
